export enum ContractStatus {
  Completed = 1,
  Pending = 2,
}
